import React, { useState } from 'react';
import { mobileCombustion } from '../../../Pages/Questionnaire/directEmission';
import TextFieldNumber from '../../../../components/TextFieldNumber';
import {
  AutocompleteCategories,
  AutocompleteFreesolo,
  Select,
} from '../fields';
import { Overlay } from '../Title/index.styles';

import { useGhgOrganization, useLanguage } from 'src/common/hooks';
import { Form, FormBox } from './index.styles';
import FormButtons from '../FormButtons';
import { vehicle_names_en, vehicle_names_pl } from './data';
import { autoCompleteOptions } from '../../../../utils/helpers';

export default function MobileCombustionConsumptionForm({
  state,
  setState,
  id,
  active,
  setActive,
  choices,
  units,
  commitState,
  existingVehicles,
}: {
  state: mobileCombustion[];
  setState: Function;
  id: number;
  active: undefined | number;
  setActive: Function;
  units: string[][];
  choices: (string | string[][])[][];
  commitState: (state: mobileCombustion[]) => void;
  existingVehicles: string[];
}) {
  const { t, language } = useLanguage();

  const [amount_per_period_error_state, set_amount_per_period_error_state] =
    useState(false);
  const [type_of_fuel_error_state, set_type_of_fuel_error_state] =
    useState(false);
  const [unit_error_state, set_unit_error_state] = useState(false);
  const [manual_factor_error_state, set_manual_factor_error_state] =
    useState(false);
  const [distance_travelled_error_state, set_distance_travelled_error_state] =
    useState(false);

  let amount_per_period_error = false;
  let type_of_fuel_error = false;
  let unit_error = false;
  let manual_factor_error = false;
  const amount_per_period_validation = (value: string) => {
    if (value === '') amount_per_period_error = true;
    return amount_per_period_error;
  };

  const type_of_fuel_validation = (value: string) => {
    if (value === '') type_of_fuel_error = true;
    return type_of_fuel_error;
  };
  const unit_validation = (value: string) => {
    if (value === '') unit_error = true;
    return unit_error;
  };
  const manual_factor_validation = (value: string) => {
    if (value === '') manual_factor_error = true;
    return manual_factor_error;
  };

  const setAmountPerPeriod = (value: string) => {
    amount_per_period_validation(value);
    set_amount_per_period_error_state(false);
    const newForms = [...state];
    let commutingType = newForms[id];
    commutingType = {
      name_of_equipement: commutingType.name_of_equipement,
      unit_of_fuel: commutingType.unit_of_fuel,
      manual_factor: commutingType.manual_factor,
      type_of_fuel: commutingType.type_of_fuel,
      amount_per_period: value,
      comment: commutingType.comment,
      distance_travelled: commutingType.distance_travelled,
    };
    newForms[id] = commutingType;
    setState(newForms);
    if (value === '') {
      set_amount_per_period_error_state(true);
    }
  };

  const setNameOfEquipment = (value: string) => {
    const newForms = [...state];
    let commutingType = newForms[id];
    commutingType = {
      name_of_equipement: value,
      unit_of_fuel: commutingType.unit_of_fuel,
      manual_factor: commutingType.manual_factor,
      type_of_fuel: commutingType.type_of_fuel,
      amount_per_period: commutingType.amount_per_period,
      comment: commutingType.comment,
      distance_travelled: commutingType.distance_travelled,
    };
    newForms[id] = commutingType;
    setState(newForms);
  };

  const setTypeOfFuel = (value: string) => {
    type_of_fuel_validation(value);
    set_type_of_fuel_error_state(false);
    const newForms = [...state];
    let commutingType = newForms[id];
    commutingType = {
      name_of_equipement: commutingType.name_of_equipement,
      unit_of_fuel: commutingType.unit_of_fuel,
      manual_factor: commutingType.manual_factor,
      type_of_fuel: value,
      amount_per_period: commutingType.amount_per_period,
      comment: commutingType.comment,
      distance_travelled: commutingType.distance_travelled,
    };
    newForms[id] = commutingType;
    setState(newForms);
    if (value === '') {
      set_type_of_fuel_error_state(true);
    }
  };

  const setManualFactor = (value: string) => {
    manual_factor_validation(value);
    set_manual_factor_error_state(false);
    const newForms = [...state];
    let commutingType = newForms[id];
    commutingType = {
      name_of_equipement: commutingType.name_of_equipement,
      unit_of_fuel: commutingType.unit_of_fuel,
      manual_factor: value === '' ? null : value,
      type_of_fuel: commutingType.type_of_fuel,
      amount_per_period: commutingType.amount_per_period,
      comment: commutingType.comment,
      distance_travelled: commutingType.distance_travelled,
    };
    newForms[id] = commutingType;
    setState(newForms);

    if (newForms[id].type_of_fuel === 'other_manual_factor' && value === '') {
      set_manual_factor_error_state(true);
    }
  };

  const setDistanceTravelled = (value: string) => {
    set_distance_travelled_error_state(false);
    const newForms = [...state];
    let commutingType = newForms[id];
    commutingType = {
      name_of_equipement: commutingType.name_of_equipement,
      unit_of_fuel: commutingType.unit_of_fuel,
      manual_factor: commutingType.manual_factor,
      type_of_fuel: commutingType.type_of_fuel,
      amount_per_period: commutingType.amount_per_period,
      comment: commutingType.comment,
      distance_travelled: value,
    };
    newForms[id] = commutingType;
    setState(newForms);
    if (value === '') {
      set_distance_travelled_error_state(true);
    }
  };

  const setUnit = (value: string) => {
    unit_validation(value);
    set_unit_error_state(false);
    const newForms = [...state];
    let commutingType = newForms[id];
    commutingType = {
      name_of_equipement: commutingType.name_of_equipement,
      unit_of_fuel: value,
      manual_factor: commutingType.manual_factor,
      type_of_fuel: commutingType.type_of_fuel,
      amount_per_period: commutingType.amount_per_period,
      comment: commutingType.comment,
      distance_travelled: commutingType.distance_travelled,
    };
    newForms[id] = commutingType;
    setState(newForms);
    if (value === '') set_unit_error_state(true);
  };

  const handleSend = (data: any) => {
    if (
      !amount_per_period_error &&
      !unit_error &&
      !type_of_fuel_error &&
      !manual_factor_error
    ) {
      commitState(data);
    }
  };

  const defineErrors = async () => {
    if (state[id].amount_per_period === '') {
      set_amount_per_period_error_state(true);
      amount_per_period_error = true;
    }

    if (state[id].type_of_fuel === '') {
      set_type_of_fuel_error_state(true);
      type_of_fuel_error = true;
    }

    if (state[id].unit_of_fuel === '') {
      set_unit_error_state(true);
      unit_error = true;
    }

    if (
      state[id].type_of_fuel === 'other_manual_factor' &&
      !state[id].manual_factor
    ) {
      set_manual_factor_error_state(true);
      manual_factor_error = true;
    }
  };

  const handleRemove = async () => {
    const tempState = [...state];
    tempState.splice(id, 1);
    commitState(tempState);
  };

  return (
    <>
      {active === id && <Overlay onClick={() => setActive(undefined)} />}
      <Form active={active === id}>
        <div onClick={() => setActive(id)}>
          <FormBox variant="100">
            <AutocompleteFreesolo
              active
              index={2}
              max={4}
              options={[]}
              error={false}
              helperText={
                existingVehicles?.includes(state[id].name_of_equipement)
                  ? t('direct-emission.mobile-combustion.vehicle-exists')
                  : undefined
              }
              label={t('direct-emission.mobile-combustion.name_of_equipement')}
              value={
                state[id].name_of_equipement === null
                  ? ''
                  : state[id].name_of_equipement
              }
              setValue={(e: string) =>
                setNameOfEquipment(autoCompleteOptions(e))
              }
            />
          </FormBox>
          <FormBox variant="50">
            <AutocompleteCategories
              active
              index={1}
              max={12}
              // @ts-ignore
              options={choices}
              label={t(`direct-emission.mobile-combustion.type_of_fuel`)}
              error={type_of_fuel_error_state}
              value={state[id].type_of_fuel}
              setValue={(e: string) => setTypeOfFuel(e)}
            />
          </FormBox>
          <FormBox variant="50">
            <Select
              active
              index={6}
              max={4}
              options={units}
              label={t('direct-emission.mobile-combustion.unit')}
              error={unit_error_state}
              value={state[id].unit_of_fuel}
              setValue={(value: string) => setUnit(value)}
            />
          </FormBox>

          <FormBox variant="100">
            <TextFieldNumber
              label={t('direct-emission.mobile-combustion.amount_per_period')}
              active
              error={amount_per_period_error_state}
              index={1}
              value={
                state[id].amount_per_period === null
                  ? ''
                  : state[id].amount_per_period
              }
              setValue={(e: string) => setAmountPerPeriod(e)}
            />
          </FormBox>

          {state[id].type_of_fuel === 'other_manual_factor' && (
            <FormBox variant="100">
              <TextFieldNumber
                type="factor"
                label={t('direct-emission.mobile-combustion.manual_factor')}
                active
                error={manual_factor_error_state}
                index={3}
                // @ts-ignore
                value={
                  state[id].manual_factor === null
                    ? ''
                    : state[id].manual_factor
                }
                setValue={(e: string) => setManualFactor(e)}
              />
            </FormBox>
          )}

          <FormBox variant="100">
            <TextFieldNumber
              label={t(
                'direct-emission.mobile-combustion.distance_travelled_field'
              )}
              active
              error={distance_travelled_error_state}
              index={4}
              value={state[id].distance_travelled ?? ''}
              setValue={(e: string) => setDistanceTravelled(e)}
            />
          </FormBox>
        </div>
        {active === id && (
          <FormButtons
            canCopy={
              state[id].amount_per_period !== '' &&
              state[id].type_of_fuel !== '' &&
              state[id].unit_of_fuel !== '' &&
              (state[id].type_of_fuel !== 'other_manual_factor' ||
                !!state[id].manual_factor)
            }
            setActive={setActive}
            state={state}
            setState={setState}
            id={id}
            onClickRemove={() => handleRemove()}
            onClickAccept={() =>
              defineErrors().then(() => {
                handleSend(state);
              })
            }
          />
        )}
      </Form>
    </>
  );
}
